import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./sobre_mim_carinagaldini_makeup.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_carinagaldini_makeup: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.sobre_mim_carinagaldini_makeup}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/carinagaldini_makeup" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Carina Galdini" />
                </div>
                <h2>Carina Galdini</h2>
                <p>
                    Sou maquiadora profissional com 24 anos de experiência, sendo 20 deles dedicados à maquiagem de noivas - uma das minhas maiores paixões.
                </p>
                <p>
                    Ao longo da minha carreira, busquei constante evolução, participando de cursos e treinamentos exclusivos com grandes referências da área, como Adriana Propício, Guilherme Nogueira, Pri Lessa e Lua Andrade.
                </p>
                <p>
                    Atualmente, estou à frente de um Studio completo, onde reuni uma equipe de cabeleireiras, manicures, maquiadoras e esteticista. Juntas, oferecemos um atendimento diferenciado, sempre com foco em qualidade, sofisticação e na realização do sonho de cada cliente.
                </p>
                <p className={styles.pLogo}>
                    <img className={styles.logo} src={require("./src/logo.png")} />
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href="https://wa.me/5517988232421?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/6YZ4hRzySMqEqBPp9" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/carinagaldini.makeup?igsh=dGozc2xpd3NhOXV6" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_carinagaldini_makeup;
